import { createSlice } from '@reduxjs/toolkit'
import { REHYDRATE } from 'redux-persist'

export const initialState = {
    loaded: false,
    value: '',
}

export const announcementSlice = createSlice({
    name: 'settings/announcement',
    initialState,
    reducers: {
        setAnnouncement: (state, action) => {
            state.value = action.payload || ''
            state.loaded = true
        },
    },
    extraReducers: (builder) => {
        // Same reasoning as nameSlice: keep the persisted `value` so the bar
        // paints from cache immediately, but force `loaded` back to false so
        // the fetch-on-mount effect still revalidates against the server
        // instead of trusting the cached announcement forever.
        builder.addCase(REHYDRATE, (state) => {
            state.loaded = false
        })
    },
})

export const { setAnnouncement } = announcementSlice.actions

export default announcementSlice.reducer
